<div class="friend-list-content">
  <slotcom-divider></slotcom-divider>
  @for (friend of friends; track friend) {
    <slotcom-friends-item [friend]="friend"></slotcom-friends-item>
  }
</div>
